// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"b30e378e","684":"e70f6e27"}[chunkId] + ".chunk.js";
};